import { InteractionStatus } from '@azure/msal-browser';
import { useStore } from 'effector-react';
import { useEffect, useMemo } from 'react';
import { Loading } from '../../../../components/loading/loading.component';
import { Guard } from '../../../../features/features.types';
import { useAutenticacao } from '../../../../hooks/autenticacao/autenticacao.hook';
import { captacao } from '../../../../infra/configs/environment/environment.configs';
import { IdExterno } from '../../../../models/usuario.model';
import { $autenticacao } from '../../../../stores/autenticacao/autenticacao.store';
import { autenticado as onUsuarioAutenticado, setIsLead } from '../../../../stores/usuario/usuario.store';
import { handleSearchParams } from '../../../../utils/handle-search-params/handle-search-params';

export const AuthGuard: Guard = ({ render, fallback }) => {
  const dataFactory = useMemo(() => handleSearchParams, []);
  const { origem } = dataFactory();
  const origemAppAluno = origem === 'APP_ALUNO';

  const {
    loginHint,
    isLead,
    inProgress,
    idExterno: searchIdExterno,
    possuiConta,
    getContaAtiva,
    acquireToken,
    signIn,
    signUp,
    signOut,
  } = useAutenticacao({
    dataFactory,
  });

  const loading = useMemo(() => <Loading ariaLabel="Carregando página" />, []);

  const idExterno: IdExterno = useMemo(
    () => ({
      atila: searchIdExterno?.atila ?? null,
      email: loginHint,
    }),
    [loginHint, searchIdExterno],
  );

  const { autenticado, pendente, erro } = useStore($autenticacao);

  // Tratamento do login
  useEffect(() => {
    if (!autenticado && loginHint && inProgress === InteractionStatus.None) {
      const conta = getContaAtiva();
      setIsLead(isLead);

      if (conta) {
        acquireToken();
      } else if (possuiConta === false) {
        signUp();
      } else {
        signIn();
      }
    } else if (!origemAppAluno && !loginHint && inProgress === InteractionStatus.None) {
      window.location.href = captacao;
    }
  }, [
    acquireToken,
    autenticado,
    getContaAtiva,
    inProgress,
    isLead,
    loginHint,
    signIn,
    signOut,
    signUp,
    origemAppAluno,
    possuiConta,
  ]);

  return useMemo(() => {
    if (pendente) {
      return loading;
    }

    const usuarioAutenticado = autenticado && !pendente && !erro;
    const possuiIdentificacao = isLead || idExterno.atila;

    if (usuarioAutenticado && possuiIdentificacao) {
      const dadosUsuario = isLead ? ({ email: loginHint } as IdExterno) : idExterno;

      onUsuarioAutenticado(dadosUsuario);
      return render;
    }

    localStorage.removeItem('idExterno.atila');
    localStorage.removeItem('origem');

    return fallback;
  }, [pendente, autenticado, erro, isLead, idExterno, fallback, loading, loginHint, render]);
};
